module.exports = __webpack_public_path__ + "static/media/box-link1.2772f41f.png";